<script setup lang="ts">
    import { useTRDocumentStore } from './TRDocumentStore';
    import { onMounted } from 'vue';

    const store = useTRDocumentStore();

    onMounted(store.init);

</script>

<template>
    <h1 class="title">
        <b-icon
            icon="file-document-check-outline" />
        TR document revision
    </h1>
    <h2 class="subtitle">
        Maintain revisions of library data with regards to Technical Requirement documents
    </h2>
    <hr>
    <router-view name="detailsView" />
</template>

<style>
.trdocument-section-header {
    color: var(--eq-north-sea-2);
    border-bottom: solid 1px var(--eq-north-sea-3);
    font-weight: 400;
}
</style>
